var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v("仓库管理"),
          ]),
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { path: "/warehouseStock" } } },
            [_vm._v("仓库库存")]
          ),
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { path: "/wareUpdateList" } } },
            [_vm._v("库存调整列表")]
          ),
          _vm.iffix
            ? _c("el-breadcrumb-item", [_vm._v("修改库存调整")])
            : _c("el-breadcrumb-item", [_vm._v("填写库存调整")]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "context" },
        [
          _c("div", { staticClass: "left" }, [
            _c("div", { staticClass: "top" }, [_vm._v("库存调整单")]),
            _c(
              "div",
              { staticClass: "tableBorder" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm.iffix
                    ? _c("span", [
                        _vm._v("调整编号：" + _vm._s(_vm.content.oddNumbers)),
                      ])
                    : _c("span", [
                        _vm._v("调整编号：" + _vm._s(_vm.content.oddNumber)),
                      ]),
                  _c("span", [
                    _c("span", [
                      _vm._v("申请人：" + _vm._s(_vm.content.createdByName)),
                    ]),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "创建时间：" +
                          _vm._s(_vm.$moment(_vm.content.createdTime))
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    ref: "table",
                    attrs: { data: _vm.tableData },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "50" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "序号", type: "index", width: "50" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "title",
                        label: "商品信息",
                        "min-width": "200",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                {
                                  staticClass: "opli",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDetail(props.row)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(props.row.title) + " ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    !_vm.iffix
                      ? _c("el-table-column", {
                          attrs: { prop: "frontQuantity", label: "原来库存" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "opli",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDetail(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(props.row.frontQuantity) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2809488528
                          ),
                        })
                      : _vm._e(),
                    _vm.iffix
                      ? _c("el-table-column", {
                          attrs: {
                            width: "100",
                            prop: "frontQuantity",
                            label: "提交时库存",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "opli",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDetail(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(props.row.frontQuantity) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2809488528
                          ),
                        })
                      : _vm._e(),
                    _vm.iffix
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "realTimeQuantity",
                            label: "实时库存",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "opli",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDetail(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(props.row.realTimeQuantity) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3694723774
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { prop: "laterQuantity", label: "调整库存为" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                {
                                  staticClass: "opli",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDetail(props.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.laterQuantity) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "调整数量" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              Number(props.row.laterQuantity) >
                              Number(props.row.frontQuantity)
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "opli",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDetail(props.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " + " + _vm._s(props.row.fixNum) + " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticClass: "opli",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDetail(props.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(props.row.fixNum) + " "
                                      ),
                                    ]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "warAdName",
                        label: "调整原因",
                        "min-width": "150",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              props.row.warAdName
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "opli",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDetail(props.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(props.row.warAdName) + " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticClass: "opli",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDetail(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v("无")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "right" },
            [
              _vm._m(0),
              _vm.nodate
                ? _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: { model: _vm.form, "label-width": "80px" },
                    },
                    [
                      _c(
                        "div",
                        [
                          _vm.show
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "商品名称" } },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", disabled: "" },
                                    model: {
                                      value: _vm.form.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "title", $$v)
                                      },
                                      expression: "form.title",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.show
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "原来库存" } },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", disabled: "" },
                                    model: {
                                      value: _vm.form.wareTotal,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "wareTotal", $$v)
                                      },
                                      expression: "form.wareTotal",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.show
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "仓库数量" } },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", disabled: "" },
                                    model: {
                                      value: _vm.form.wareNumber,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "wareNumber", $$v)
                                      },
                                      expression: "form.wareNumber",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.form.warRequestList && _vm.show
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "调整仓库" } },
                                _vm._l(
                                  _vm.form.warRequestList,
                                  function (ite, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              value: ite.warName,
                                              size: "mini",
                                              "value-key": "warId",
                                              placeholder: "请选择",
                                              disabled: "",
                                            },
                                          },
                                          _vm._l(
                                            _vm.wareList.list,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: item.name,
                                                  value: item,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _vm.show
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                },
                                              },
                                              [
                                                _vm.iffix
                                                  ? _c("el-input-number", {
                                                      staticStyle: {
                                                        "margin-right": "10px",
                                                      },
                                                      attrs: {
                                                        size: "mini",
                                                        min: 0,
                                                        placeholder:
                                                          "请输入库存数量",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeWareNumber(
                                                            ite
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          ite.realTimeQuantity,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            ite,
                                                            "realTimeQuantity",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "ite.realTimeQuantity",
                                                      },
                                                    })
                                                  : _c("el-input-number", {
                                                      staticStyle: {
                                                        "margin-right": "10px",
                                                      },
                                                      attrs: {
                                                        size: "mini",
                                                        min: 0,
                                                        placeholder:
                                                          "请输入库存数量",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeWareNumber(
                                                            ite
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: ite.number,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            ite,
                                                            "number",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "ite.number",
                                                      },
                                                    }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "调整原因" } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "select",
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择",
                                size: "mini",
                                clearable: "",
                                "value-key": "id",
                              },
                              on: {
                                change: _vm.changeReson,
                                "visible-change": (v) =>
                                  _vm.visibleChange(
                                    v,
                                    "select",
                                    _vm.selectClick
                                  ),
                              },
                              model: {
                                value: _vm.form.reson,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "reson", $$v)
                                },
                                expression: "form.reson",
                              },
                            },
                            _vm._l(_vm.whyList.list, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.deliveryName,
                                  value: item,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "nodate" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../assets/kong.png"),
                        alt: "",
                      },
                    }),
                    _c("span", [_vm._v("请选择左侧信息")]),
                  ]),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "管理调整原因",
                "append-to-body": "",
                width: "30%",
                visible: _vm.dialogFormVisible,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFormVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialogContent" },
                [
                  _c(
                    "el-form",
                    { attrs: { "label-width": "80px" } },
                    [
                      _c("el-form-item", { attrs: { label: "添加原因" } }, [
                        _c(
                          "div",
                          { staticClass: "add" },
                          [
                            _c("el-input", {
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.whyValue,
                                callback: function ($$v) {
                                  _vm.whyValue = $$v
                                },
                                expression: "whyValue",
                              },
                            }),
                            _c("i", {
                              staticClass: "el-icon-circle-plus-outline",
                              staticStyle: {
                                "margin-left": "20px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.addWhy },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "whyList",
                      staticStyle: {
                        pading: "2px 0px",
                        height: "405px",
                        overflow: "auto",
                      },
                    },
                    _vm._l(_vm.whyList.list, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: {
                            "margin-bottom": "5px",
                            display: "flex",
                            "align-items": "center",
                            height: "40px",
                            "padding-left": "10px",
                          },
                          on: {
                            dblclick: function ($event) {
                              return _vm.updateItem($event, item)
                            },
                          },
                        },
                        [
                          _vm.id != item.id
                            ? _c("i", {
                                staticClass: "el-icon-remove-outline",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteWhy(item.id)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.id != item.id
                            ? _c(
                                "span",
                                { staticStyle: { "margin-left": "10px" } },
                                [_vm._v(_vm._s(item.deliveryName))]
                              )
                            : _vm._e(),
                          _vm.id == item.id
                            ? _c("input", {
                                directives: [
                                  { name: "focus", rawName: "v-focus" },
                                ],
                                staticStyle: { height: "40px" },
                                attrs: { type: "text" },
                                on: {
                                  blur: function ($event) {
                                    return _vm.updateBlur(
                                      $event.target.value,
                                      item
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "submit" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.submitEvent },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [_c("span", [_vm._v("操作")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }